import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { PageheaderComponent } from '../../../../../Components/pageheader/pageheader.component';
import { IPageHeader } from '../../../../../Components/pageheader/pageHeader.model';
import { ArticlesViewComponent } from '../../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../../base.component';
import { IPopup } from '../../../../../Components/popup/popup.model';
import { SchoolApiService } from '../../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../../constants';
import { AutoUnsubscribe } from '../../../../../Services/autoUnsubscribe.service';
import { IList } from '../../../../../Models/list.model';
import { IResponse } from '../../../../../Models/response.model';
import { ISchoolArticle } from '../../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-kg',
  standalone: true,
  imports: [PageheaderComponent, ArticlesViewComponent],
  providers: [SchoolApiService],
  templateUrl: './kg.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KgComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'academics', path: '/academics' },
    children: [
      {
        title: 'stages',
        path: '/academics#STAGES_SECTION',
      },
      {
        title: 'kg',
        path: null,
      },
    ],
  };
  public kgArticlesArray: IPopup[] = [];
  public start: number = 0;
  public limit: number = 10;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = NATIONAL_PAGES.ACADEMICS.STAGES.KG;
  }

  ngOnInit(): void {
    this.onPaginateEvent(0);
  }

  onPaginateEvent($event: number) {
    this.start = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.kgArticlesArray = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
